export default "__VITE_ASSET__B4jL2qGy__"